<!--<mat-card>-->
    <div fxLayout='row' fxLayoutAlign='space-between' fxLayoutGap='1rem'>
        <div fxFlex='100'>
            <ngx-skeleton-loader count='1' ></ngx-skeleton-loader>
        </div>
    </div>
<!--</mat-card>-->
  